import { useState, useMemo, useEffect } from 'react';
import { isPastDate } from '@wix/da-ds/pkg/Time/functions';
import { getAllowOffers, getHasBuyItNow, getIsPending, getHasOwnOffer, getHasRejectedOffer } from '../../../../../../utils/adoptables';
export default function useAdoptableState(deviation) {
    var _deviation_extended_adoptable_offers, _deviation_extended_adoptable, _deviation_extended, _deviation_adoptable_offers, _deviation_adoptable, _deviation_adoptable_offers1, _deviation_adoptable1, _deviation_adoptable_fixedPrice, _deviation_adoptable2, _deviation_extended_adoptable1, _deviation_extended1;
    var _deviation_extended_adoptable_offers_offerList;
    const offersList = (_deviation_extended_adoptable_offers_offerList = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : (_deviation_extended_adoptable_offers = _deviation_extended_adoptable.offers) === null || _deviation_extended_adoptable_offers === void 0 ? void 0 : _deviation_extended_adoptable_offers.offerList) !== null && _deviation_extended_adoptable_offers_offerList !== void 0 ? _deviation_extended_adoptable_offers_offerList : [];
    const hasOffers = offersList.length > 0;
    const hasOwnOffer = getHasOwnOffer(deviation);
    const hasRejectedOffer = getHasRejectedOffer(deviation);
    const hasBuyItNow = getHasBuyItNow(deviation);
    // this is kind of hacky because the deviation entity is not actually updated when timer ends
    // however, I don't think we want to force a page reload in this case, or manually alter entities (do we?)
    const offerEndTime = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : (_deviation_adoptable_offers = _deviation_adoptable.offers) === null || _deviation_adoptable_offers === void 0 ? void 0 : _deviation_adoptable_offers.offerEndTime;
    const [offerTimerHasEnded, setOfferTimerHasEnded] = useState(offerEndTime ? isPastDate(offerEndTime) : false);
    const onTimerEnd = ()=>setOfferTimerHasEnded(true);
    const isPending = useMemo(()=>getIsPending(deviation), [
        deviation
    ]);
    const allowOffers = useMemo(()=>!isPending && getAllowOffers(deviation) && !offerTimerHasEnded, [
        isPending,
        deviation,
        offerTimerHasEnded
    ]);
    const minOfferPrice = allowOffers && ((_deviation_adoptable1 = deviation.adoptable) === null || _deviation_adoptable1 === void 0 ? void 0 : (_deviation_adoptable_offers1 = _deviation_adoptable1.offers) === null || _deviation_adoptable_offers1 === void 0 ? void 0 : _deviation_adoptable_offers1.offerPrice) || 0;
    const fixedPrice = hasBuyItNow && ((_deviation_adoptable2 = deviation.adoptable) === null || _deviation_adoptable2 === void 0 ? void 0 : (_deviation_adoptable_fixedPrice = _deviation_adoptable2.fixedPrice) === null || _deviation_adoptable_fixedPrice === void 0 ? void 0 : _deviation_adoptable_fixedPrice.fixedPrice) || 0;
    // Seller flags
    const isSeller = (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable1 = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable1 === void 0 ? void 0 : _deviation_extended_adoptable1.isCreator;
    const canSellerViewOffers = isSeller && (allowOffers || isPending);
    // Buyer flags
    const isBuyer = !isSeller;
    const canBuyNow = isBuyer && hasBuyItNow;
    const canMakeNewOffer = isBuyer && allowOffers && !hasOwnOffer;
    const canManageExistingOffer = isBuyer && allowOffers && hasOwnOffer && !hasRejectedOffer;
    const canBuyerViewOffers = isBuyer && isPending;
    // Other flags
    const canSeeMinOfferPrice = allowOffers && !hasOffers;
    useEffect(()=>{
        setOfferTimerHasEnded(offerEndTime ? isPastDate(offerEndTime) : false);
    // We update the value of `offerTimerHasEnded` when `deviation` prop changes, to avoid having a stale state.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deviation
    ]);
    return {
        isSeller,
        canBuyNow,
        canMakeNewOffer,
        canManageExistingOffer,
        canBuyerViewOffers,
        canSellerViewOffers,
        canSeeMinOfferPrice,
        hasOffers,
        offersList,
        minOfferPrice,
        fixedPrice,
        offerEndTime,
        offerTimerHasEnded,
        onTimerEnd
    };
}
